export default __webpack_public_path__ + "501fd5c7f585620308fc3aec0edc3874.png";